<template>
  <div class="row justify-center mt-4">
    <div class="col-md-6 mt-4">
      <v-card class="mx-auto" max-width="1200" tile>
        <BlueHeader></BlueHeader>
        <div class="mt-3">
          <div class="row border-blue-bottom">
            <div class="row" :class="tableClients ? 'col-md-4' : 'col-md-6'">
              <v-icon
                large
                v-text="'mdi-menu-left'"
                class="pointer"
                @click="
                  tableClients
                    ? $router.push('/clearing-house')
                    : ((addNew = false),
                      (clientDetails = false),
                      (tableClients = true),
                      getData())
                "
              ></v-icon>

              <h3 class="mb-4 mt-5 ml-3 font-weight-bold warning--text">
                <span v-if="tableClients"> Employer Clients </span>
                <span v-else-if="addNew">Add New Employer Client</span>
                <span v-else-if="clientDetails">Employer Client Details</span>
              </h3>
            </div>
            <div class="col-md-4" v-if="tableClients">
              <v-text-field
                class="input-control mr-5"
                prepend-inner-icon="mdi-magnify"
                @input="searchInput"
                light
                dense
                outlined
                placeholder="Search Employer Clients"
              ></v-text-field>
            </div>

            <div :class="tableClients ? 'col-md-4' : 'col-md-6'" align="end">
              <div
                class="pointer"
                v-if="showDetails || !tableClients || !addNewTPA"
              >
                <svg
                  @click="dialog = true"
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.25 7.51196H27.75"
                    stroke="#326AB3"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M21.75 28.5H8.25C7.45435 28.5 6.69129 28.1839 6.12868 27.6213C5.56607 27.0587 5.25 26.2956 5.25 25.5V7.5H24.75V25.5C24.75 26.2956 24.4339 27.0587 23.8713 27.6213C23.3087 28.1839 22.5456 28.5 21.75 28.5Z"
                    stroke="#326AB3"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.62402 7.5V6.813C9.62402 5.4039 10.1838 4.05252 11.1802 3.05614C12.1765 2.05976 13.5279 1.5 14.937 1.5C16.3461 1.5 17.6975 2.05976 18.6939 3.05614C19.6903 4.05252 20.25 5.4039 20.25 6.813V7.5"
                    stroke="#326AB3"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.967 13.5V22.5"
                    stroke="#326AB3"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M18.0449 13.5V22.5"
                    stroke="#326AB3"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <v-btn
                v-if="tableClients"
                class="my-1 gray-border-buttons ml-6"
                @click="
                  (addNew = true),
                    (tableClients = false),
                    (clientDetails = false),
                    (groupid = ''),
                    (employername = ''),
                    (tpas = [])
                "
              >
                <svg
                  class="mr-2"
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 7.5H15"
                    stroke="#707070"
                    stroke-width="2"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.5 0V15"
                    stroke="#707070"
                    stroke-width="2"
                    stroke-linejoin="round"
                  />
                </svg>

                New
              </v-btn>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <v-simple-table
            v-if="tableClients"
            fixed-header
            height="70vh"
            class="no-padding tr-custom-height"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">EMPLOYER NAME</th>
                  <th class="text-left">GROUP ID</th>
                </tr>
              </thead>

              <tbody
                v-if="items.length > 0 && !filterItems"
                class="text-gray tr-custom-height"
              >
                <tr
                  class="text-gray"
                  id="remove-hover"
                  v-for="(item, index) in items"
                  :key="index"
                >
                  <td>
                    <a
                      v-if="item && item.employername"
                      class="text-underline"
                      @click="showClient(item)"
                      >{{ item.employername }}
                    </a>
                    <a v-else @click="showClient(item)">/</a>
                  </td>
                  <td>{{ item.groupid }}</td>
                </tr>
              </tbody>
              <tbody v-else-if="items.length < 1 && filterItems">
                <v-col md="12" cols="12">
                  <v-alert
                    border="bottom"
                    colored-border
                    type="warning"
                    elevation="2"
                    class="text-gray"
                  >
                    Sorry! No results found
                  </v-alert>
                </v-col>
              </tbody>

              <tbody v-else>
                <v-col md="12" v-if="!loader">
                  There are no clients currently added to your account.
                  <a
                    @click="
                      (addNew = true),
                        (tableClients = false),
                        (clientDetails = false)
                    "
                  >
                    Click to add your clients</a
                  >
                </v-col>
                <v-row v-else class="justify-center col-md-12 mt-5">
                  <v-progress-circular
                    :size="100"
                    class="text-center"
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-row>
              </tbody>
            </template>
          </v-simple-table>
          <div v-else-if="addNew" class="row justify-center mt-5">
            <div class="col-md-8">
              <v-text-field
                outlined
                label="Employer Client Name"
                v-model="employername"
                hide-details=""
              ></v-text-field>
            </div>
            <div class="col-md-8">
              <v-text-field
                outlined
                hide-details=""
                label="Group Id"
                v-model="groupid"
              ></v-text-field>
            </div>
            <div class="col-md-8">
              <v-select
                outlined
                hide-details=""
                multiple
                label="TPA / Carrier Admin"
                :items="allTpas"
                item-text="tpaname"
                item-value="_id"
                v-model="tpas"
              >
                <template v-slot:prepend-item>
                  <div class="fixed-list-item">
                    <v-list-item>
                      <v-list-item-content class="p-2">
                        <v-text-field
                          dense
                          placeholder="Search"
                          @input="searchTpas"
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </div>
                </template>
              </v-select>
            </div>

            <div class="col-md-8 mb-10">
              <v-btn class="blue-buttons" block @click="addNewTPA"
                >Add New</v-btn
              >
            </div>
          </div>
          <div v-else-if="clientDetails" class="row justify-center mt-5">
            <div class="col-md-8">
              <v-text-field
                outlined
                label="Employer Client Name"
                v-model="employername"
                hide-details=""
              ></v-text-field>
            </div>
            <div class="col-md-8">
              <v-text-field
                outlined
                hide-details=""
                label="Group Id"
                v-model="groupid"
              ></v-text-field>
            </div>

            <div class="col-md-8">
              <v-select
                outlined
                hide-details=""
                multiple
                label="TPA / Carrier Admin"
                :items="allTpas"
                item-text="tpaname"
                item-value="_id"
                v-model="tpas"
              >
                <template v-slot:prepend-item>
                  <div class="fixed-list-item">
                    <v-list-item>
                      <v-list-item-content class="p-2">
                        <v-text-field
                          dense
                          placeholder="Search"
                          @input="searchTpas"
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </div>
                </template>
              </v-select>
            </div>

            <div class="col-md-8 mb-10">
              <v-btn class="blue-buttons" block @click="updateItem"
                >Update</v-btn
              >
            </div>
          </div>
        </div>
      </v-card>

      <v-dialog v-model="dialog" width="500">
        <v-card>
          <v-card-title class="">
            Are you sure you want to delete?
          </v-card-title>

          <v-card-text class="mt-5 mb-5">
            <v-btn class="blue-buttons" block @click="removeItem">
              YES - DELETE</v-btn
            >
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <a class="text-underline mt-3 mb-3" @click="dialog = false">
              Cancel
            </a>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <router-view></router-view>
      <successModal
        ref="success_modal"
        v-on:confirm="closeSuccessModal"
      ></successModal>
    </div>
  </div>
</template>
<script>
import Header from "../../../DigitalVendorInvoices/Layout/HeaderPage.vue";
import api from "../../../../../services/api";
import tpas from "../../../../../store/JSONS/employer.json";
import successModal from "../../../../TablesTemplate/SuccessDialog.vue";
import BlueHeader from "../BlueHeader.vue";
import firebase from "../../../../../firebase.js";
import { mapGetters } from "vuex";
const db = firebase.firestore();
export default {
  data() {
    return {
      showDetails: false,
      dialog: false,
      items: [],
      singleItem: null,
      sortBy: "",
      type: "",
      solutions: [],
      favorites: [],
      filterItems: false,
      filteredArray: [],
      selectedItem: 1,
      tableClients: true,
      addNew: false,
      clientDetails: false,
      dialog: false,
      tpaName: "",
      payerId: "",
      carrierAdmin: "",
      tpaIndex: "",
      tpaId: "",
      groupid: "",
      employername: "",
      allTpas: [],
      tpas: [],
      filterTpas: [],
      filterArray: [],
      loader: true,
    };
  },
  components: {
    Header,
    successModal,
    BlueHeader,
  },
  computed: {
    isChildren() {
      let bool = false;
      if (this.$route.meta && this.$route.meta.isChildren) {
        bool = true;
      }
      return bool;
    },
    ...mapGetters(["getClearingHouseDetails"]),
  },
  created() {
    this.getData();
    this.getTpas();
  },

  methods: {
    searchTpas(val) {
      this.allTpas = this.filterTpas.filter((el) => {
        if (
          el["tpaname"] &&
          el["tpaname"].toString().toLowerCase().includes(val.toLowerCase())
        ) {
          return el["tpaname"]
            .toString()
            .toLowerCase()
            .includes(val.toLowerCase());
        }
      });
    },
    showClient(item) {
      this.groupid = "";
      this.employername = "";
      this.tpaId = "";
      this.tpas = [];

      this.groupid = item.groupid;
      this.employername = item.employername;
      this.tpaId = item._id;
      this.addNew = false;
      this.tableClients = false;
      this.clientDetails = true;
      this.tpas = item.tpas;
    },
    getTpas(item) {
      api()
        .get("/clearinghouse/tpas")
        .then((res) => {
          this.allTpas = res.data;
          this.filterTpas = res.data;

          if (this.getClearingHouseDetails) {
            this.showClient(this.getClearingHouseDetails);
            this.$store.commit("setClientDetails", null);
          }
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
        });
    },
    getData() {
      this.loader = true;
      api()
        .get("/clearinghouse/employers")
        .then((res) => {
          if (res) {
            this.items = res.data;
            this.filterArray = res.data;
            this.filteredArray = res.data;
            this.loader = false;
          }
        });
    },
    removeItem() {
      api()
        .delete("/clearinghouse/employers/" + this.tpaId)
        .then((res) => {
          if (res) {
            this.dialog = false;
            this.$refs.success_modal.openPopUp(
              "Employer Client removed successfully"
            );
          }
        });
    },
    updateItem() {
      api()
        .put("/clearinghouse/employers/" + this.tpaId, {
          employername: this.employername,
          groupid: this.groupid,
          tpas: this.tpas,
        })
        .then((res) => {
          if (res) {
            this.$refs.success_modal.openPopUp(
              "Employer Client updated successfully"
            );
          }
        })
        .catch((error) => {
          console.error("Error updating document: ", error);
        });
    },
    closeSuccessModal() {
      this.getData();
      this.$refs.success_modal.closePopUp();
      this.addNew = false;
      this.showDetails = false;
      this.tableClients = true;
    },
    addNewTPA() {
      if (this.employername && this.groupid) {
        api()
          .post("/clearinghouse/employers", {
            employername: this.employername,
            groupid: this.groupid,
            tpas: this.tpas,
          })
          .then((res) => {
            if (res) {
              this.$refs.success_modal.openPopUp(
                "Employer Client added successfully"
              );
            }
          })
          .catch((error) => {
            console.error("Error updating document: ", error);
          });
      }
    },
    invite() {},
    add() {},
    exportFun() {
      this.exportData("tblData");
    },

    searchInput(val) {
      this.items = this.filterArray.filter((el) => {
        if (
          el["groupid"] &&
          el["groupid"].toString().toLowerCase().includes(val.toLowerCase())
        ) {
          return el["groupid"]
            .toString()
            .toLowerCase()
            .includes(val.toLowerCase());
        } else if (
          el["employername"] &&
          el["employername"]
            .toString()
            .toLowerCase()
            .includes(val.toLowerCase())
        ) {
          return el["employername"]
            .toString()
            .toLowerCase()
            .includes(val.toLowerCase());
        }
      });
      if (this.items.length < 1) {
        this.filterItems = true;
      } else {
        this.filterItems = false;
      }
    },

    searchMembers() {},
  },
};
</script>
<style>
.div-shadow {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px,
    rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
}
</style>